'use client';

import { useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import './ImageBlock.css';
import { IImageBlock } from './interfaces';
import { pinchZoom } from '@/shared/lib/pinchZoom';

export const ImageBlock = ({ element }: IImageBlock) => {
  const [aspectRatio, setAspectRatio] = useState('wide');
  const description = element.description || '';
  const image = element.image ? `https://api.blwall.com${element.image.data.attributes.url}` : '';

  const getRatio = (w: number, h: number) => {
    if (h / w > 1) {
      setAspectRatio('tall');
    }
  };
  const handleLoadingComplete = (img: HTMLImageElement) => {
    const ratio = getRatio(img.naturalWidth, img.naturalHeight);
    pinchZoom(img);
  };
  const objFitContain = element.fitInside ? 'contain' : '';

  const base64Img =
    'data:image/bmp;base64,Qk32BAAAAAAAADYAAAAoAAAACAAAAAgAAAABABgAAAAAAMAAAAATCwAAEwsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQaACglDTAoP01OO0pNM0VML0NNNEdSPk5WRVNYSFVXbHN5anJ4ZW53Y213ZW96anN9bXZ9b3Z8hoyRhIqRgoiQgYiSg4uViI+Yi5GZjZKYk5mdk5idkpiek5mgl52knaKpoaespKmtmJ6fmJ6gmqCinqOnpKisqq+ysbW3tbq7mJ+dmqCenaOio6eoqq6vsra3ur6+v8TDmJ+bmaCdnqOipKmorLCwtLi4vcG/w8fF';

  if (element.linkSlug) {
    const pathname = element.linkToArticle ? '/topics' : '/portfolio';
    return (
      <Link
        href={pathname + '/' + element.linkSlug}
        target="_blank"
        rel="noopener noreferrer"
        className={'imgBlock'}
      >
        <Image
          width={900}
          height={900}
          onLoad={event => handleLoadingComplete(event.currentTarget)}
          src={image}
          alt={description}
          className={`imgBlock__img ${objFitContain}  ${aspectRatio} `}
          loading="lazy"
          placeholder="blur"
          blurDataURL={base64Img}
        />
        <figcaption className={'imgBlock__description'}>{description}</figcaption>
      </Link>
    );
  }

  return (
    <figure className={'imgBlock'}>
      <Image
        width={900}
        height={900}
        onLoad={event => handleLoadingComplete(event.currentTarget)}
        src={image}
        alt={description}
        className={`imgBlock__img ${objFitContain} ${aspectRatio}`}
      />
      <figcaption className={'imgBlock__description'}>{description}</figcaption>
    </figure>
  );
};
